import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { loginProcess } from '../../actions/authActions';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getJoins, deleteJoin } from '../../actions/joinUsAction';
import { editJoin } from './../../actions/joinUsActionUD';
import { showJoin } from './../../actions/joinUsActionUD';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Growl } from 'primereact/growl';
import { linkDomain } from '../../mainConf/index';
import Lightbox from 'react-image-lightbox';
import defaultBackground from './../../assets/images/defaultBackground.png';
import { imageDomain } from '../../mainConf';
import { takeAgencyRole } from '../../actions/authActions';
import { Helmet } from 'react-helmet';

class ShowJoinusByAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: '',
      pageDescription: '',
      selectedJoin: {},
      requestSuccessMessage: '',
      deleteSuccessMessage: '',
      joinus: [],
      updatedReferenceId: '',
      updatedRank: '',
      total_joinus: 0,
      pageNumber: 1,
      bgURL: '',

      showMainPhoto: false,
    };
  }

  componentWillReceiveProps(nextProps, nextState) {
    let result2 = [];
    if (
      nextProps.deleteSuccessMessage !== this.state.deleteSuccessMessage &&
      this.state.deleteSuccessMessage !== '' &&
      nextProps.deleteSuccessMessage !== undefined &&
      nextProps.deleteSuccessMessage !== ''
    ) {
      this.setState({
        deleteSuccessMessage: nextProps.deleteSuccessMessage,
      });

      switch (nextProps.deleteSuccessMessage) {
        case 'حذف الاقتراح المحدد':
          this.growl.show({
            severity: 'success',
            summary: 'تم حذف الاقتراح المحدد',
          });
          this.state.joinus.forEach((obj, index) => {
            if (obj.reference_id !== this.state.updatedReferenceId) {
              result2.push(obj);
            }
          });
          this.setState({ joinus: result2 });
          break;

        default:
          break;
      }
    } else if (
      nextProps.requestSuccessMessage !== this.state.requestSuccessMessage &&
      this.state.requestSuccessMessage !== ''
    ) {
      this.setState({
        requestSuccessMessage: nextProps.requestSuccessMessage,
      });

      switch (nextProps.requestSuccessMessage) {
        case 'إظهار الاقتراح المحدد':
          this.growl.show({
            severity: 'success',
            summary: 'تم إظهار الاقتراح المحدد',
          });
          this.state.joinus.forEach((obj, index) => {
            result2.push(obj);

            if (obj.reference_id === this.state.updatedReferenceId) {
              result2[index].visible = !obj.visible;
            }
          });
          this.setState({ joinus: result2 });
          break;
        case 'إخفاء الاقتراح المحدد':
          this.growl.show({
            severity: 'success',
            summary: 'تم إخفاء الاقتراح المحدد',
          });
          this.state.joinus.forEach((obj, index) => {
            result2.push(obj);
            if (obj.reference_id === this.state.updatedReferenceId) {
              result2[index].visible = !obj.visible;
            }
          });
          this.setState({ joinus: result2 });
          break;

        default:
          break;
      }
    } else if (
      nextProps.joinus !== this.state.joinus &&
      nextProps.joinus[0] !== undefined &&
      nextProps.joinus[0] !== null
    ) {
      this.setState({
        joinus: nextProps.joinus,
        total_joinus: nextProps.joinus[0].total_joinus,
      });
    } else {
      this.setState({
        joinus: [],
        total_joinus: 0,
      });
    }
  }
  componentDidMount() {
    this.props.getJoins(this.props.ikarAdmin);
  }

  onChangeVisibility = async (reference_id, chargedStatus, e) => {
    e.preventDefault();

    var join_us = {};
    var processType = '';
    switch (chargedStatus) {
      case 'visible':
        if (!window.confirm('إظهار الاقتراح المحدد؟')) {
          return;
        }
        join_us = {
          reference_id,
          visible: true,
        };
        processType = 'إظهار الاقتراح المحدد';
        break;
      case 'hide':
        if (!window.confirm('إخفاء الاقتراح المحدد؟')) {
          return;
        }
        join_us = {
          reference_id,
          visible: false,
        };
        processType = 'إخفاء الاقتراح المحدد';
        break;
      default:
        break;
    }
    await this.setState({
      requestSuccessMessage: 'ready',
      updatedReferenceId: reference_id,
    });
    const joinDate = { join_us };
    await this.props.showJoin(joinDate, processType);
  };
  joinStatusTemplate = (rowData, column) => {
    return (
      <span
        className={classnames(
          'text-center',
          { 'text-success': rowData.visible },
          { 'text-danger': !rowData.visible }
        )}
      >
        {rowData.visible ? <span>نعم</span> : <span>لا</span>}
      </span>
    );
  };
  onEditJoin = async (e) => {
    if (!window.confirm('تعديل الاقتراح المحدد ؟')) {
      e.preventDefault();
      return;
    }
  };
  showDetailsTemplate = (rowData, column) => {
    return (
      <React.Fragment>
        {rowData.visible ? (
          <Button
            //icon="pi pi-check"
            // icon="fa fa-store"
            //iconPos="right"
            className="p-button-success btn_process"
            tooltip="إخفاء الاقتراح"
            tooltipOptions={{
              position: 'bottom',
              event: 'hover',
            }}
            onClick={this.onChangeVisibility.bind(
              this,
              rowData.reference_id,
              'hide'
            )}
          >
            <FontAwesomeIcon icon={['fas', 'store']}></FontAwesomeIcon>
          </Button>
        ) : (
          <Button
            // icon="fa fa-store"
            //iconPos="right"
            className="p-button-danger btn_process"
            tooltip="إظهار الاقتراح"
            tooltipOptions={{
              position: 'bottom',
              event: 'hover',
            }}
            onClick={this.onChangeVisibility.bind(
              this,
              rowData.reference_id,
              'visible'
            )}
          >
            <FontAwesomeIcon icon={['fas', 'store']}></FontAwesomeIcon>
          </Button>
        )}
        {/* </div>
          <div className="col-6 text-center px-0"> */}

        <Button
          //icon="pi pi-check"
          // icon="fa fa-money-check"
          //iconPos="right"
          className="p-button-success btn_process"
          tooltip="حذف الاقتراح المحدد"
          tooltipOptions={{
            position: 'bottom',
            event: 'hover',
          }}
          onClick={this.onDeleteJoin.bind(
            this,
            rowData.reference_id,
            'remove_faq'
          )}
        >
          <FontAwesomeIcon icon={['fas', 'times']}></FontAwesomeIcon>
        </Button>

        <Link
          to={`/adminDashBoard/edit_joinus?join_id=${rowData.reference_id}`}
        >
          <Button
            // icon="fa fa-edit"
            //iconPos="right"
            className="p-button-warning btn_process"
            tooltip="تعديل الاقتراح"
            tooltipOptions={{
              position: 'bottom',
              event: 'hover',
            }}
            onClick={this.onEditJoin.bind(this)}
            disabled={rowData.business_status === 'مؤرشف'}
          >
            <FontAwesomeIcon icon={['fas', 'edit']}></FontAwesomeIcon>
          </Button>
        </Link>
      </React.Fragment>
    );
  };
  export = () => {
    this.dt.exportCSV();
  };
  onSearchSubmit = (recordsPerPage, pageNumber) => {
    this.setState({ pageNumber });
  };
  showPhotoTemplate = (rowData, column) => {
    var bgURL = '';
    // var thumbnail = '';

    if (
      rowData.photo === null ||
      rowData.photo === undefined ||
      rowData.photo.length === 0
    ) {
      bgURL = defaultBackground;
      // thumbnail = defaultBackground;
    } else {
      bgURL = `${imageDomain}/${rowData.photo[0]}`;
      // thumbnail = `${imageDomain}/${rowData.thumbnail[0]}`;
    }
    return (
      <React.Fragment>
        <img
          ////////src={thumbnail}
          src={bgURL}
          alt=""
          style={{ width: '100px', height: '50px' }}
          onClick={() =>
            this.setState({
              showMainPhoto: true,
              bgURL,
            })
          }
        />
      </React.Fragment>
    );
  };
  handleTakeAgencyRole = (referenceId, e) => {
    if (!window.confirm('الدخول كالمستخدم المحدد ؟')) {
      return;
    }
    this.props.takeAgencyRole(referenceId);
    // this.props.history.push("/dashBoard/properties_by_agency");
    //this.props.history.push('/');
  };
  onNewSearch = () => {
    this.setState({ pageNumber: 1 });
  };
  onDeleteJoin = async (reference_id, e) => {
    let processType = 'حذف الاقتراح المحدد';
    if (!window.confirm('حذف الاقتراح المحدد ؟')) {
      return;
    }
    await this.setState({
      deleteSuccessMessage: 'ready',
      updatedReferenceId: reference_id,
    });
    await this.props.deleteJoin(reference_id, processType);
  };

  render() {
    const {
      joinus,
      total_joinus,
      pageNumber,
      bgURL,
      showMainPhoto,
    } = this.state;
    var joinHeader = (
      <div className="px-2 py-0" style={{ textAlign: 'right' }}>
        <Button
          type="button"
          icon="pi pi-external-link"
          iconPos="left"
          label="تصدير الجدول الى ملف اكسل CSV"
          onClick={this.export}
        ></Button>
      </div>
    );

    return (
      <React.Fragment>
        <Helmet>
          <title>{this.state.pageTitle}</title>
          <meta name="description" content={this.state.pageDescription} />
        </Helmet>
        <div className="mb-3 text-center my-2">
          <h1 className="main_title">قائمة انضم إلينا </h1>
        </div>
        <div className="text-right mx-2">
          <a href={`${linkDomain}/adminDashBoard/add_joinus`}>
            ادخال اقتراح جديد
          </a>
        </div>
        <div className="property-container">
          <div className="container-fluid">
            <Growl ref={(el) => (this.growl = el)} />
            {/* row justify-content-around align-items-center  */}
            <div className="table_container mt-1">
              <DataTable
                ref={(el) => {
                  this.dt = el;
                }}
                value={joinus}
                responsive={true}
                //header="المكاتب العقارية"
                selectionMode="single"
                selection={this.state.selectedJoin}
                onSelectionChange={(e) => {
                  this.setState({ selectedJoin: e.value });
                }}
                header={joinHeader}
              >
             
                <Column
                  field="title"
                  header="العنوان"
                  sortable={true}
                  className="table_td"
                  // style={{ width: "150px" }}
                />
                <Column
                  field="content"
                  header="التفاصيل"
                  sortable={true}
                  className="table_td"
                  // style={{ width: "150px" }}
                />

                <Column
                  body={this.showDetailsTemplate}
                  // header="الاجراءات"
                  style={{ width: '150px' }}
                  className="table_td table-functions"
                />
              </DataTable>
              {showMainPhoto && (
                <Lightbox
                  mainSrc={bgURL}
                  nextSrc={bgURL}
                  prevSrc={bgURL}
                  onCloseRequest={() => this.setState({ showMainPhoto: false })}
                  onMovePrevRequest={
                    () => {
                      return;
                    }
                    // this.setState({
                    //   showMainPhoto: (showMainPhoto + url.length - 1) % url.length
                    // })
                  }
                  onMoveNextRequest={
                    () => {
                      return;
                    }
                    // this.setState({
                    //   photoIndex: (showMainPhoto + 1) % url.length
                    // })
                  }
                />
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ShowJoinusByAdmin.propTypes = {
  joinus: PropTypes.array.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  ikarAdmin: PropTypes.bool.isRequired,
  editJoin: PropTypes.func.isRequired,
  showJoin: PropTypes.func.isRequired,
  getJoins: PropTypes.func.isRequired,
  deleteJoin: PropTypes.func.isRequired,
  requestSuccessMessage: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  joinus: state.join.joinus,
  isLoggedIn: state.auth.isLoggedIn,
  ikarAdmin: state.auth.ikarAdmin,
  requestSuccessMessage: state.joinUD.requestSuccessMessage,
  deleteSuccessMessage: state.join.deleteSuccessMessage,
  // short_id: state.agencyUD.short_id,
  // short_id2: state.agency.short_id2,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    loginProcess,
    getJoins,
    editJoin,
    showJoin,
    deleteJoin,
    takeAgencyRole,
  })
)(ShowJoinusByAdmin);
